import { setSession } from '../store/auth';
import { initAssetsSignals } from './assets';

export function renderLoginPage(): string {
  return `
    <s-app-provider>
      <style>
        .login-page-container {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          width: 100vw;
          background-color: var(--p-color-bg-app, #f6f6f7);
          box-sizing: border-box;
          padding: 1rem;
        }
        .login-logo {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          background-color: var(--p-color-bg-accent, #008060);
          color: white;
          border-radius: 8px;
          font-weight: bold;
          font-size: 1.5rem;
        }
      </style>
      <div class="login-page-container">
        <s-box padding="large-500" border="base" borderRadius="base" background="surface" shadow="100" style="width: 100%; max-width: 400px;">
          <s-form id="login-form" autocomplete="on">
            <s-stack gap="base">
              <!-- Logo and Heading -->
              <s-stack gap="small" alignment="center">
                <div class="login-logo">[OPM]</div>
                <s-heading element="h1">Sign in to OPM</s-heading>
                <s-text tone="subdued">Managed Printing System Portal</s-text>
              </s-stack>

              <s-divider color="base"></s-divider>

              <!-- Credentials Input fields -->
              <s-email-field 
                label="Email address" 
                name="email" 
                id="login-email" 
                required 
                autocomplete="email"
                auto
              ></s-email-field>

              <s-password-field 
                label="Password" 
                name="password" 
                id="login-password" 
                required
              ></s-password-field>

              <!-- Submit Button -->
              <s-button 
                variant="primary" 
                id="btn-login-submit" 
                style="width: 100%;"
              >
                Sign In
              </s-button>
            </s-stack>
          </s-form>
        </s-box>
      </div>
    </s-app-provider>
  `;
}

export function setupLoginPageListeners() {
  const emailField = document.getElementById('login-email') as any;
  const passwordField = document.getElementById('login-password') as any;
  const submitBtn = document.getElementById('btn-login-submit') as any;
  const loginForm = document.getElementById('login-form');

  // Focus Control: Upon mounting, the component sets focus on the #login-email input field dynamically.
  if (emailField) {
    setTimeout(() => {
      emailField.focus();
    }, 50);
  }

  // Clear errors when the user inputs new text
  if (emailField) {
    emailField.addEventListener('input', () => {
      emailField.removeAttribute('error');
    });
  }
  if (passwordField) {
    passwordField.addEventListener('input', () => {
      passwordField.removeAttribute('error');
    });
  }

  if (!loginForm) return;

  const handleSubmit = async (e: Event) => {
    e.preventDefault();

    if (!emailField || !passwordField) return;

    const email = emailField.value;
    const password = passwordField.value;

    if (!email || !password) {
      if (!email) {
        emailField.setAttribute('error', 'Email address is required');
      }
      if (!password) {
        passwordField.setAttribute('error', 'Password is required');
      }
      return;
    }

    // Reset error attributes at start of submit attempt
    emailField.removeAttribute('error');
    passwordField.removeAttribute('error');

    // Loading State: While authenticating, the submit button is set to loading="true" to block duplicate submissions.
    if (submitBtn) {
      submitBtn.setAttribute('loading', 'true');
      submitBtn.setAttribute('disabled', 'true');
    }

    try {
      const res = await fetch('/api/v1/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (res.ok) {
        const data = await res.json();
        setSession(data.accessToken);
        await initAssetsSignals();
        window.location.hash = '#dashboard';
      } else {
        const errData = await res.json().catch(() => ({ error: 'Invalid email or password' }));
        const errMsg = errData.error || 'Invalid email or password';
        emailField.setAttribute('error', errMsg);
        passwordField.setAttribute('error', errMsg);
      }
    } catch (err) {
      emailField.setAttribute('error', 'Connection error. Please try again.');
      passwordField.setAttribute('error', 'Connection error. Please try again.');
    } finally {
      if (submitBtn) {
        submitBtn.removeAttribute('loading');
        submitBtn.removeAttribute('disabled');
      }
    }
  };

  loginForm.addEventListener('submit', handleSubmit);

  if (submitBtn) {
    submitBtn.addEventListener('click', handleSubmit);
  }
}